/**
 * Tradução dos erros do BFF de verificação para o usuário. Sem React: é
 * compartilhado pelo wizard do `signup-id`, pela tela de senha e pelos testes.
 */

/** Erros do BFF em português; o resto cai na mensagem genérica da tela. */
export const OTP_ERRORS: Record<string, string> = {
  invalid_code: 'Código inválido. Confira e tente de novo.',
  expired: 'O código expirou. Peça um novo código.',
  not_found: 'O código expirou. Peça um novo código.',
  too_many_attempts:
    'Muitas tentativas. Peça um novo código para continuar.',
  resend_throttled:
    'Você pediu um código há pouco. Aguarde um minuto e tente de novo.',
  invalid_cpf: 'Informe um CPF válido com 11 dígitos.',
  invalid_email: 'Informe um e-mail válido.',
  invalid_phone: 'Informe um celular válido com DDD para concluir o cadastro.',
  // Na tela de senha não há campo de contato: se o dado se perdeu entre as
  // telas (aba nova, storage bloqueado), a ação possível é voltar.
  missing_phone:
    'Não encontramos seu celular. Volte e informe o celular com DDD para concluir.',
  missing_email: 'Não encontramos seu e-mail. Volte e informe o e-mail para concluir.',
  sms_send_failed: 'Não foi possível enviar o SMS. Tente novamente.',
  email_send_failed: 'Não foi possível enviar o e-mail. Tente novamente.',
  // Sem resposta legível (servidor fora, DNS, CORS): quase nunca é a conexão
  // do usuário, então a copy não a culpa.
  network_error:
    'Não foi possível falar com o serviço de cadastro. Tente de novo em instantes.',
}

const OFFLINE_ERROR =
  'Você está sem conexão. Verifique sua internet e tente de novo.'

/** Só o `false` prova algo: `onLine === true` não garante que a rede funciona. */
function isOffline(): boolean {
  return typeof navigator !== 'undefined' && navigator.onLine === false
}

function describeNetworkError(): string {
  return isOffline() ? OFFLINE_ERROR : OTP_ERRORS.network_error
}

/** Mesma tradução de erro para as sub-etapas do `signup-id` e do `signup-password`. */
export function describeOtpError(errorCode: string, fallback: string): string {
  if (errorCode === 'network_error') return describeNetworkError()
  return OTP_ERRORS[errorCode] || fallback
}

/**
 * A config não tem erro de domínio: o que não é falha de rede é o BFF
 * respondendo algo inesperado, e o código vai na mensagem para o suporte
 * saber o que aconteceu sem abrir o console.
 */
export function describeConfigError(errorCode: string): string {
  if (errorCode === 'network_error') return describeNetworkError()
  return `O serviço de cadastro respondeu com um erro (${errorCode}). Tente de novo em instantes.`
}

/**
 * Erro de identidade no fechamento feito pela tela de senha: o celular e o
 * e-mail já passaram pelo passo 3, então "inválido" aqui significa que o dado
 * não chegou — a copy manda voltar, não corrigir um campo que não existe.
 */
export function mapClosingError(errorCode: string): string {
  if (errorCode === 'invalid_phone') return 'missing_phone'
  if (errorCode === 'invalid_email') return 'missing_email'
  return errorCode
}
